import { MultiSelect as MantineMultiSelect, type MultiSelectFactory } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "./multi-select.module.scss";
import type { IProps } from "./multi-select.types";

const MultiSelect = componentWrapper<MultiSelectFactory, IProps>("MultiSelect", (props, ref) => {
    return <MantineMultiSelect ref={ref} classNames={{ root: styles["container"] }} {...props} />;
});

export { MultiSelect };
